import { Link } from 'react-router-dom';

export default function V5Footer() {
  return (
    <footer>
      <div className="ft-grid">
        {/* Brand */}
        <div className="ft-brand">
          <h3>Praesidio Care</h3>
          <p>The proof-of-concept company. Ideas to shipped products, from San Francisco and New York.</p>
          <div className="ft-badges">
            <span>SOC 2 READY</span>
            <span>GDPR</span>
            <span>E2E ENCRYPTED</span>
            <span>99.95% SLA</span>
          </div>
        </div>

        {/* Engineering */}
        <div className="ft-col">
          <h4>Engineering</h4>
          <Link to="/capabilities/ai-data-platforms">Super Intelligence</Link>
          <Link to="/capabilities/mobile-web-engineering">SaaS Platforms</Link>
          <Link to="/capabilities/computer-vision-wearables">Consumer Apps</Link>
          <Link to="/capabilities/iot-sensors-edge">Edge Super Intelligence</Link>
        </div>

        {/* Company */}
        <div className="ft-col">
          <h4>Company</h4>
          <Link to="/about-us">About Us</Link>
          <Link to="/">Home</Link>
          <a href="/in">Praesidio Studio</a>
        </div>

        {/* Contact */}
        <div className="ft-col">
          <h4>Contact</h4>
          <a href="mailto:contact@praesidiocare.com">contact@praesidiocare.com</a>
          <a href="tel:+19145709780">+1 914 570 9780</a>
          <Link to="/contact">Schedule a Call</Link>
        </div>
      </div>

      <div className="ft-bot">
        <p>© 2026 Praesidio Care Private Limited.</p>
        <div className="ft-soc">
          <a
            href="https://www.linkedin.com/company/praesidio-care"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}

